export default "__VITE_ASSET__RPizlrco__"